import React from 'react';
import { useTranslation } from 'react-i18next';

export default function LoadingState() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-gray-200 border-t-blue-600 rounded-full animate-spin mx-auto mb-4" />
        <p className="text-gray-500 text-sm">{t('manage.loadingBooking', 'Loading your booking...')}</p>
      </div>
    </div>
  );
}
